export default __webpack_public_path__ + "static/media/care.c02ce8ad.png";